(function () {
    document.addEventListener("DOMContentLoaded", (event) => {
        const filterSectionContainers = document.querySelectorAll(".filter-section-container");

        Array.prototype.forEach.call(filterSectionContainers, (filterSectionContainer) => {
            const filterInputsContainers = filterSectionContainer.querySelectorAll(".filter-inputs");
            const filterItems = document.querySelectorAll(".filter-item");

            let filters = [];

            Array.prototype.forEach.call(filterInputsContainers, (filterInputsContainer, i) => {
                const filterEls = filterInputsContainer.querySelectorAll(".filter-input");

                filters[i] = "null";

                Array.prototype.forEach.call(filterEls, (filterEl) => {
                    filterEl.addEventListener("change", () => {
                        const resetFilter = filterInputsContainer.querySelector(".filter-input[value='null']");
                        let checkedFilterEls = filterInputsContainer.querySelectorAll("input.filter-input:checked");

                        if (checkedFilterEls.length === 0) {
                            resetFilter.checked = true;
                        }

                        if (filterEl.value === "null" && filterEl.checked) {
                            Array.prototype.forEach.call(filterEls, (filterEl) => {
                                filterEl.checked = false;
                            });
                            filterEl.checked = true;
                        } else if (filterEl.value !== "null" && filterEl.checked) {
                            resetFilter.checked = false;
                        }


                        checkedFilterEls = filterInputsContainer.querySelectorAll("input.filter-input:checked");

                        filters[i] = ([...checkedFilterEls].map((checkedFilterEl) => checkedFilterEl.value));

                        let nodesFilteredGroups = [];

                        let j = 0;

                        for (let filter of filters) {
                            let results = [];
                            if (filter[0] === "null") {
                                Array.prototype.forEach.call(filterItems, (filterItem) => {
                                    results.push(filterItem);
                                });
                            } else {
                                Array.prototype.forEach.call(filterItems, (filterItem) => {
                                    const filterItemFilters = filterItem.getAttribute("data-filter");
                                    for (let i = 0; i < filter.length; i++) {
                                        if (filterItemFilters.includes(filter[i])) {
                                            results.push(filterItem);
                                        }
                                    }
                                });
                            }
                            nodesFilteredGroups[j] = results;
                            j++;
                        }

                        let concatArr = [];

                        for (let nodesFilteredGroup of nodesFilteredGroups) {
                            let nodesFilteredGroupSet = new Set(nodesFilteredGroup);
                            let uniqArray = [...nodesFilteredGroupSet]
                            concatArr = [...concatArr,...uniqArray];
                        }

                        Array.prototype.forEach.call(filterItems, (filterItem) => {
                            filterItem.classList.add("is-filtered");
                        });

                        for (let i = 0; i < concatArr.length; i++) {
                            let itemRepitation = countInArray(concatArr, concatArr[i]);

                            if (itemRepitation === filters.length) {
                                concatArr[i].classList.remove("is-filtered");
                            }
                        }
                    });
                });     
            });
        });
    });

    function countInArray(array, what) {
        let count = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i] === what) {
                count++;
            }
        }
        return count;
    }
})();